import React from 'react';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import Scroll from '../components/Scroll';
import Hero from '../components/Hero';
import SEO from '../components/SEO';

const SiteData = {
  title: 'Usługi',
  slug: '/uslugi',
};

export default ({ data }) => {
  const { edges } = data.allServicesDataJson;
  return (
    <div>
      <SEO isSeo siteData={SiteData} type="Local Business" />
      <div className="theme-page padding-bottom-70">
        <Hero image={data.servicesHero.sizes} heading="Zobacz co możemy dla Ciebie zrobić">
          <div className=" margin-top-67 padding-bottom-20">
            <Scroll type="id" element="services">
              <a className="more">
                <span>dowiedz się więcej</span>
              </a>
            </Scroll>
          </div>
        </Hero>
        <div id="services" className="row gray full-width page-header vertical-align-table">
          <div className="row full-width padding-top-bottom-50 vertical-align-cell">
            <div className="row">
              <div className="page-header-left">
                <h1>nasze usługi</h1>
              </div>
              <div className="page-header-right">
                <div className="bread-crumb-container">
                  <label>JESTEŚ TUTAJ:</label>
                  <ul className="bread-crumb">
                    <li>
                      <Link to="/">STRONA GŁÓWNA</Link>
                    </li>
                    <li className="separator">&#47;</li>
                    <li>USŁUGI</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clearfix">
          <div className="row">
            <ul className="services-list clearfix padding-top-70">
              {edges.map(({ node }) => (
                <li key={node.name}>
                  <Link to={node.slug} title={node.name}>
                    <Img
                      sizes={data[node.image1].sizes}
                      imgStyle={{ objectPosition: '0 0' }}
                      style={{ width: '100%', maxHeight: '247px' }}
                    />
                    <h4 className="box-header">
                      {node.name}
                      <span className="template-arrow-menu" />
                    </h4>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export const query = graphql`
  query ServicesPage {
    allServicesDataJson {
      edges {
        node {
          name
          image1
          slug
        }
      }
    }

    servicesHero: imageSharp(id: { regex: "/servicesHero/" }) {
      sizes(maxWidth: 1484, maxHeight: 660) {
        ...GatsbyImageSharpSizes
      }
    }

    service_1: imageSharp(id: { regex: "/service_1/" }) {
      sizes(maxWidth: 400, maxHeight: 270) {
        ...GatsbyImageSharpSizes
      }
    }

    service_3: imageSharp(id: { regex: "/service_3/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }

    service_5: imageSharp(id: { regex: "/service_5/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }

    service_7: imageSharp(id: { regex: "/service_7/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }

    service_9: imageSharp(id: { regex: "/service_9/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }

    service_11: imageSharp(id: { regex: "/service_11/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_14: imageSharp(id: { regex: "/service_14/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/uslugi.js